import { useCallback, useLayoutEffect, useRef } from 'react';

export function useEvent<Fn extends (...args: any[]) => any>(handler: Fn) {
	const handlerRef = useRef<Fn>(handler);
	useLayoutEffect(() => {
		handlerRef.current = handler;
	});
	return useCallback((...args: Parameters<Fn>): ReturnType<Fn> => {
		const fn = handlerRef.current;
		return fn?.(...args);
	}, []);
}
